import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import { consultantmage } from "../Constant/Index";
import { GET_NEAR_PHARMACY } from "../redux/Slices/AuthSlice";
import { getPatientnearsetApi } from "../network/Network";
import { useDispatch, useSelector } from "react-redux";

const UserPrescriptionAddress = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.Auth?.token);
  const orderdetail = useSelector((state) => state?.Auth?.orderdetail);
  const prescriptiondetail = useSelector((state) => state?.Auth?.prescriptiondetail);
  const [getNearapi, setGetNearapi] = useState("");
  const [location, setLocation] = useState({
    latitude: null,
    longitude: null,
    error: null,
  });
  // Get Nearest Pharmacy Api
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getPatientnearsetApi(
          location.latitude,
          location.longitude,
          token
        );
        dispatch(GET_NEAR_PHARMACY(res?.data));
        setGetNearapi(res?.data);
      } catch (error) {
      }
    };

    fetchData();
  }, [location.latitude, location.longitude]);

  //   Get Nearset Loaction
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            error: null,
          });
        },
        (error) => {
          setLocation({
            ...location,
            error: error.message,
          });
        }
      );
    } else {
      setLocation({
        ...location,
        error: "Geolocation is not supported by this browser.",
      });
    }
  }, []);
  //   ============

  return (
    <>
      <Header />
      <PageHeader pagename="User Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <UserProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="main-headind d-flex align-items-center extra-bg-14 radius-20 dark-color gap-4 p-4 mb-3">
                      <div className="edit-btn back">
                        <Link
                          to={`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`}
                        >
                          <div className="nav-anchor">
                            <i className="fa-solid fa-arrow-left"></i>
                          </div>
                        </Link>
                      </div>
                      <div className="content-qty   ">
                        <div className="d-flex gap-3 align-items-center">
                          <img
                            src={
                              orderdetail?.physician_detail?.profile_image_url
                                ? orderdetail?.physician_detail
                                    ?.profile_image_url
                                : consultantmage
                            }
                            className="img-fluid profie_img"
                            alt=""
                          />
                          <div>
                            <h4 className="main-heading-font level-6 ">
                              {orderdetail?.physician_detail?.title}
                            </h4>
                            <h5 className="primary-medium-font level-8 extra-color-15">
                              Physician
                            </h5>
                            <h4 className="primary-medium-font level-7 ">
                              <span className="icon-point">
                                <i className="fa-solid fa-location-dot"></i>
                              </span>{" "}
                              {orderdetail?.physician_detail?.address}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
                      <h4 className="main-heading-font level-6 ">
                        Prescription
                      </h4>
                      <div className="row mb-4">
                      {prescriptiondetail?.prescription?.prescriptions?.map(
                          (item, pdindex) => {
                            return (
                              <>
                                <div className="col-lg-3" key={pdindex}>
                                  <div className="content-qty extra-bg-17 radius-20 p-3 dark-color ">
                                    <h4 className="primary-medium-font level-7 ">
                                      {item?.prescription}
                                    </h4>
                                    <h5 className="primary-medium-font level-8 extra-color-15">
                                      {item?.quantity}
                                    </h5>
                                  </div>
                                </div>
                              </>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-12">
                    <div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
                      <h4 className="main-heading-font level-6 mb-3">
                        Nearest Pharmacy Address
                      </h4>
                      <h4 className="primary-medium-font level-7 d-flex align-items-start gap-3 ">
                        <span className="icon-point">
                          <i className="fa-solid fa-location-dot"></i>
                        </span>
                        <span>{getNearapi?.nearest_pharmacy?.address}</span>
                      </h4>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-lg-12">
                    <div className="d-flex align-items-center gap-3">
                      <Link
                        className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
                        to="/user-billing-detail">
                        <span className="bg-wrapper w-100">Place Order </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UserPrescriptionAddress;
